<a class="skip-link" href="#main-content" (click)="focusMainContent($event)">Pular para o conteúdo principal</a>
<router-outlet />
